// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noticeManagementContainer * {
  margin: 0 !important;
  padding: 0 !important;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px !important;
  margin-top: 0;
  line-height: 1.2;
  padding-bottom: 0;
}

.noticeContent {
  display: flex;
  gap: 40px;
  margin-top: 20px !important; /* 제목과 컨텐츠 사이 간격 */
}

.sectionTitle {
  margin-bottom: 10px !important;
  margin: 10px 0;
  font-weight: normal;
  color: #666;
}

.editTitle {
  color: #ff6b00; /* 공지사항 수정하기 텍스트는 메인색(오렌지)으로 변경 */
}

/* 미리보기 섹션 */
.previewSection {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 0; /* 마진 제거 */
}

.previewBox {
  width: 400px;
  height: 610px;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px !important;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 10px !important; /* 박스에 상단 마진 추가 */
}

/* 내부 공지사항 카드 스타일 - 높이 증가 */
.noticeCard {
  width: 300px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 500px; /* 높이 증가 */
}

.noticeCardHeader {
  background-color: white;
  padding: 15px !important;
  text-align: center;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}

.noticeCardBody {
  padding: 20px !important;
  height: calc(100% - 50px);
  overflow-y: auto;
}

/* 수정 섹션 */
.editSection {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 0; /* 마진 제거 */
}

.editBox {
  width: 450px;
  height: 600px; /* 높이 유지 */
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 20px !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative; /* 상대 위치 설정 */
  margin-top: 10px !important; /* 박스에 상단 마진 추가 */
}

.editHeader {
  margin-bottom: 15px;
}

/* 내용과 언어 선택기를 한 줄에 배치 */
.contentAndLanguage {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contentAndLanguage h3 {
  margin: 0;
  font-weight: normal;
}

.languageSelector {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  height: 40px !important; /* 높이 고정 */
}

.languageSelector button {
  padding: 10px 20px !important; /* 패딩 증가 */
  font-size: 16px !important; /* 폰트 크기 증가 */
  height: 40px !important; /* 높이 고정 */
  min-width: 80px !important; /* 최소 너비 설정 */
  background: white;
  border: none;
  cursor: pointer;
}

.languageSelector button.active {
  background-color: #333;
  color: white;
}

.editContent {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 100px !important; /* 버튼 공간 더 확보 */
}

.editContent textarea {
  width: 100%;
  height: 100%;
  padding: 15px !important;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  resize: none;
}

/* 버튼을 박스 내부 하단에 배치 */
.actionButtons {
  display: flex;
  flex-direction: row;
  gap: 15px;
  position: absolute;
  bottom: 30px !important; /* 아래쪽 여백 증가 */
  right: 255px;
}

.resetButton {
  width: 100px; /* 초기화 버튼 너비 100px */
  height: 55px !important; /* 높이 증가 */
  background-color: #ccc;
  color: #333;
  border-radius: 4px;
  border: none;
  font-size: 17px !important; /* 폰트 크기 증가 */
  cursor: pointer;
  text-align: center;
  padding: 0 15px !important;
  flex-shrink: 0; /* 크기 유지 */
}

.submitButton {
  width: 280px; /* 수정완료 버튼 너비 280px */
  height: 55px !important; /* 높이 증가 */
  background-color: #ff6b00;
  color: white;
  border-radius: 4px;
  border: none;
  font-size: 17px !important; /* 폰트 크기 증가 */
  cursor: pointer;
  text-align: center;
  padding: 0 15px !important;
  flex-shrink: 0; /* 크기 유지 */
} `, "",{"version":3,"sources":["webpack://./src/styles/NoticeManagement.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc,EAAE,iCAAiC;AACnD;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa,EAAE,UAAU;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B,EAAE,iBAAiB;AAChD;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa,EAAE,UAAU;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa,EAAE,UAAU;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa,EAAE,UAAU;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAE,aAAa;EACjC,2BAA2B,EAAE,iBAAiB;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB,EAAE,UAAU;AACrC;;AAEA;EACE,6BAA6B,EAAE,UAAU;EACzC,0BAA0B,EAAE,aAAa;EACzC,uBAAuB,EAAE,UAAU;EACnC,0BAA0B,EAAE,aAAa;EACzC,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B,EAAE,eAAe;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB,EAAE,cAAc;EACvC,YAAY;AACd;;AAEA;EACE,YAAY,EAAE,oBAAoB;EAClC,uBAAuB,EAAE,UAAU;EACnC,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,0BAA0B,EAAE,aAAa;EACzC,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,YAAY,EAAE,qBAAqB;EACnC,uBAAuB,EAAE,UAAU;EACnC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,0BAA0B,EAAE,aAAa;EACzC,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc,EAAE,UAAU;AAC5B","sourcesContent":[".noticeManagementContainer * {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 5px !important;\n  margin-top: 0;\n  line-height: 1.2;\n  padding-bottom: 0;\n}\n\n.noticeContent {\n  display: flex;\n  gap: 40px;\n  margin-top: 20px !important; /* 제목과 컨텐츠 사이 간격 */\n}\n\n.sectionTitle {\n  margin-bottom: 10px !important;\n  margin: 10px 0;\n  font-weight: normal;\n  color: #666;\n}\n\n.editTitle {\n  color: #ff6b00; /* 공지사항 수정하기 텍스트는 메인색(오렌지)으로 변경 */\n}\n\n/* 미리보기 섹션 */\n.previewSection {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 0; /* 마진 제거 */\n}\n\n.previewBox {\n  width: 400px;\n  height: 610px;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  padding: 20px !important;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 10px !important; /* 박스에 상단 마진 추가 */\n}\n\n/* 내부 공지사항 카드 스타일 - 높이 증가 */\n.noticeCard {\n  width: 300px;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  height: 500px; /* 높이 증가 */\n}\n\n.noticeCardHeader {\n  background-color: white;\n  padding: 15px !important;\n  text-align: center;\n  font-weight: bold;\n  border-bottom: 1px solid #eee;\n}\n\n.noticeCardBody {\n  padding: 20px !important;\n  height: calc(100% - 50px);\n  overflow-y: auto;\n}\n\n/* 수정 섹션 */\n.editSection {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 0; /* 마진 제거 */\n}\n\n.editBox {\n  width: 450px;\n  height: 600px; /* 높이 유지 */\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  padding: 20px !important;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  position: relative; /* 상대 위치 설정 */\n  margin-top: 10px !important; /* 박스에 상단 마진 추가 */\n}\n\n.editHeader {\n  margin-bottom: 15px;\n}\n\n/* 내용과 언어 선택기를 한 줄에 배치 */\n.contentAndLanguage {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.contentAndLanguage h3 {\n  margin: 0;\n  font-weight: normal;\n}\n\n.languageSelector {\n  display: flex;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  overflow: hidden;\n  height: 40px !important; /* 높이 고정 */\n}\n\n.languageSelector button {\n  padding: 10px 20px !important; /* 패딩 증가 */\n  font-size: 16px !important; /* 폰트 크기 증가 */\n  height: 40px !important; /* 높이 고정 */\n  min-width: 80px !important; /* 최소 너비 설정 */\n  background: white;\n  border: none;\n  cursor: pointer;\n}\n\n.languageSelector button.active {\n  background-color: #333;\n  color: white;\n}\n\n.editContent {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 100px !important; /* 버튼 공간 더 확보 */\n}\n\n.editContent textarea {\n  width: 100%;\n  height: 100%;\n  padding: 15px !important;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  resize: none;\n}\n\n/* 버튼을 박스 내부 하단에 배치 */\n.actionButtons {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  position: absolute;\n  bottom: 30px !important; /* 아래쪽 여백 증가 */\n  right: 255px;\n}\n\n.resetButton {\n  width: 100px; /* 초기화 버튼 너비 100px */\n  height: 55px !important; /* 높이 증가 */\n  background-color: #ccc;\n  color: #333;\n  border-radius: 4px;\n  border: none;\n  font-size: 17px !important; /* 폰트 크기 증가 */\n  cursor: pointer;\n  text-align: center;\n  padding: 0 15px !important;\n  flex-shrink: 0; /* 크기 유지 */\n}\n\n.submitButton {\n  width: 280px; /* 수정완료 버튼 너비 280px */\n  height: 55px !important; /* 높이 증가 */\n  background-color: #ff6b00;\n  color: white;\n  border-radius: 4px;\n  border: none;\n  font-size: 17px !important; /* 폰트 크기 증가 */\n  cursor: pointer;\n  text-align: center;\n  padding: 0 15px !important;\n  flex-shrink: 0; /* 크기 유지 */\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
